function getPlaces(
  keyword,
  type,
  lat,
  lng,
  limit,
  viewX,
  viewY,
  scale,
  callback
) {
  return fetch(
    // `https://524ho7vm5sbczjshzmgb4abrzm0buupp.lambda-url.us-east-1.on.aws/`, // Sample response for debugging without using Google Places API quota
    `https://ctv4itr4gli5mb36gpw63cmp3m0lrxek.lambda-url.us-east-1.on.aws/?keyword=${keyword}&type=${type}&lat=${lat}&lng=${lng}&limit=${limit}&viewport=${viewX}x${viewY}&scale=${scale}`,
    {
      accept: "application/json"
    }
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(callback);
}

const PAGE_BUILDER_BASE_URL = "https://page-builder-server.fcc.lol";
const GOOGLE_API_KEY = "AIzaSyCDaUboSKd_IRDRfe_N0lIJojMkfB1Me9k";
const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoiemFjaHRlbWtpbiIsImEiOiJjbDJxd3VvbnAwNTUwM2N0MGVrYmF2Y2ZpIn0.s7e69zcQSOLP3sMI-pjEPA";

function streetViewUrl(latitude, longitude) {
  return `https://maps.googleapis.com/maps/api/streetview?size=512x512&location=${latitude},${longitude}&key=${GOOGLE_API_KEY}`;
}

function mapboxSatelliteUrl(latitude, longitude) {
  return `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/${longitude},${latitude},18,0/512x512?access_token=${MAPBOX_ACCESS_TOKEN}`;
}

function parseLatLngFromInput(input) {
  if (!input) return null;
  const match = input.match(/query=([-0-9.]+)(?:,|%2C)([-0-9.]+)/i);
  if (!match) return null;
  const latitude = parseFloat(match[1]);
  const longitude = parseFloat(match[2]);
  if (Number.isNaN(latitude) || Number.isNaN(longitude)) return null;
  return { latitude, longitude };
}

function buildAddress(parsed, fallback) {
  if (!parsed) return fallback || "";
  const cityState = [parsed.city, parsed.state].filter(Boolean).join(", ");
  const zipped = [cityState, parsed.zip].filter(Boolean).join(" ");
  const parts = [parsed.address, zipped].filter(Boolean);
  if (parts.length === 0) return fallback || "";
  return parts.join(", ");
}

function itemToPlace(item) {
  const basic = item.basicInfo || {};
  const parsed = basic.parsed || {};
  const latlng = parseLatLngFromInput(item.input);
  if (!latlng) return null;

  const images = parsed.images || {};
  const imagePath =
    (images.placePhoto && images.placePhoto.url) ||
    (images.openGraph && images.openGraph.url) ||
    item.image;
  const photos = [];
  if (imagePath) {
    photos.push({
      id: `${item.id}-og`,
      url: `${PAGE_BUILDER_BASE_URL}${imagePath}`
    });
  }
  photos.push({
    id: `${item.id}-sv`,
    url: streetViewUrl(latlng.latitude, latlng.longitude)
  });
  photos.push({
    id: `${item.id}-sat`,
    url: mapboxSatelliteUrl(latlng.latitude, latlng.longitude)
  });

  return {
    id: item.id,
    googlePlaceId: item.googlePlaceId || null,
    name: parsed.placeName || basic.title || "Unnamed place",
    address: buildAddress(parsed, basic.description),
    latlng,
    rating: typeof parsed.numStars === "number" ? parsed.numStars : null,
    photos,
    reviews: null,
    urls: { googleMaps: item.input },
    customReviews: false
  };
}

function getPagePlaces(owner, title, callback) {
  return fetch(
    `${PAGE_BUILDER_BASE_URL}/pages/by-owner-and-title/${encodeURIComponent(
      owner
    )}/${encodeURIComponent(title)}?include=owner,items`,
    {
      accept: "application/json"
    }
  )
    .then(checkStatus)
    .then(parseJSON)
    .then((data) => {
      const items = (data && data.items) || [];
      const order = (data && data.page && data.page.itemOrder) || {};
      const sorted = [...items].sort((a, b) => {
        const ao = order[a.id];
        const bo = order[b.id];
        if (ao == null && bo == null) return 0;
        if (ao == null) return 1;
        if (bo == null) return -1;
        return ao - bo;
      });
      const places = sorted.map(itemToPlace).filter(Boolean);
      const meta = {
        title: (data && data.page && data.page.title) || null
      };
      callback(places, meta);
      return { places, meta };
    });
}

function getPhotosForPlace(placeId) {
  return fetch(
    `https://ctv4itr4gli5mb36gpw63cmp3m0lrxek.lambda-url.us-east-1.on.aws/?place_id=${encodeURIComponent(
      placeId
    )}`,
    {
      accept: "application/json"
    }
  )
    .then(checkStatus)
    .then(parseJSON)
    .then((data) => (data && data.photos) || []);
}

function getWeather(lat, lng, callback) {
  return fetch(
    `https://xbinwbuc7bnkqonzu3kx654jsi0lcgrs.lambda-url.us-east-1.on.aws/?location=${lat},${lng}`,
    {
      accept: "application/json"
    }
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(callback);
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(`HTTP Error ${response.statusText}`);
  error.status = response.statusText;
  error.response = response;
  console.log(error);
  throw error;
}

function parseJSON(response) {
  return response.json();
}

const Client = { getPlaces, getPagePlaces, getPhotosForPlace, getWeather };
export default Client;
